export const validateError500 = status => status.toString()[0] === '5'
